(function () {
  'use strict';

  function addBundleToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '…';

    var cartDrawer = document.querySelector('cart-drawer');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer) {
      var sectionIds = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(btn);
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (response.status) {
        btn.innerHTML = orig;
        btn.disabled = false;
        return;
      }
      btn.innerHTML = '✓';
      if (cartDrawer) {
        cartDrawer.renderContents(response);
      } else {
        window.location = routes.cart_url;
      }
      setTimeout(function () {
        btn.innerHTML = orig;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.innerHTML = orig;
      btn.disabled = false;
    });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hx-bundle-add]');
      if (!btn || btn.disabled) return;
      addBundleToCart(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
